module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/tutorial2_e2227b.jpg";